const getters={
  getCreateAccrualForm(state) {
    return state.createAccrualFormData;
  },
  getAccrualListData(state){
    return state.accrualList;
  }
}
export default getters;